<script lang="ts">
  import CurrentPage from './current-page.svelte';

  let { data } = $props();
</script>

<CurrentPage {data} />
